import CollapsibleSection from '@/global/components/CollapsibleSection'
import Grid from '@/global/components/ui/Grid'
import { CategoriaEnum } from '@acme/auth'
import { FormFieldAutocomplete } from 'global/components/Form'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { centroCusto, empresas as empresas_api, local } from 'service/api'
import { useStore } from 'store'

export const Associacoes: React.FC = () => {
    const { watch, setValue } = useFormContext()
    const empresaId = useStore(state => state.companyId)
    const categoriaId = watch('Usuario.categoriaId')

    const { data: locaisData } = local.useFetch({
        queryParams: { empresaId },
    })
    const { data: centrosCustoData } = centroCusto.useFetch({
        queryParams: { empresaId },
    })
    const { data: empresasData } = empresas_api.useFetch()

    React.useEffect(() => {
        if (categoriaId && categoriaId == 3) {
            setValue('centroCustoIds', [])
            setValue('localIds', [])
            setValue('empresaIds', [])
        }
    }, [categoriaId])

    return categoriaId && categoriaId != CategoriaEnum.Cliente ? (
        <CollapsibleSection
            title="Associar empresa, centro de custo ou local"
            scrollToView
        >
            <Grid container>
                <Grid item xs={12}>
                    <FormFieldAutocomplete
                        name="empresaIds"
                        label="Empresas"
                        options={empresasData ?? []}
                        getOptionLabel={option => option.nomeFantasia}
                        placeholder={'Selecione uma ou mais empresas'}
                        multiple
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormFieldAutocomplete
                        name="centroCustoIds"
                        label="Centros de custo"
                        options={centrosCustoData ?? []}
                        getOptionLabel={option =>
                            option.nomeCentroCusto + ' - ' + option.codigo
                        }
                        placeholder={'Selecione um ou mais centros de custo'}
                        multiple
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormFieldAutocomplete
                        name="localIds"
                        label="Locais"
                        options={locaisData ?? []}
                        getOptionLabel={option => option.nomeLocal}
                        placeholder={'Selecione um ou mais locais'}
                        multiple
                    />
                </Grid>
            </Grid>
        </CollapsibleSection>
    ) : null
}
